/**
 * Normalizes exchange codes according to STT desktop app standards
 * Based on Ed Weinberg's specifications:
 * 1) NYE --> NYSE
 * 2) NGS --> NASDAQ
 * 3) NSC --> NASDAQ
 * 4) NSD --> NASDAQ
 * 5) AMX --> AMEX
 * 6) ARCA --> NYSEARCA
 * 7) BATS ✓ (keep as is)
 * 8) EXPM ✓ (keep as is)
 * 9) OTCQX ✓ (keep as is)
 * 10) OTCQB ✓ (keep as is)
 * 11) OTO --> OTCPK
 * 12) PINL --> OTCPK
 */

export function normalizeExchange(exchange) {
	if (!exchange) {
		return "";
	}

	const exchangeUpper = exchange.toUpperCase();

	// NYSE variations
	if (
		exchangeUpper === "NYE" ||
		exchangeUpper === "NYSE" ||
		exchangeUpper === "NYSE-ARCA" ||
		exchangeUpper === "NYSE-ARCA-ARCA"
	) {
		return "NYSE";
	}

	// NASDAQ variations
	if (
		exchangeUpper === "NGS" ||
		exchangeUpper === "NSC" ||
		exchangeUpper === "NSD" ||
		exchangeUpper === "NASDAQ" ||
		exchangeUpper === "NASDAQ-NMS" ||
		exchangeUpper === "NASDAQ-NMS-ARCA"
	) {
		return "NASDAQ";
	}

	// AMEX variations
	if (
		exchangeUpper === "AMX" ||
		exchangeUpper === "AMEX" ||
		exchangeUpper === "AMEX-ARCA" ||
		exchangeUpper === "AMEX-ARCA-ARCA"
	) {
		return "AMEX";
	}

	// ARCA variations
	if (exchangeUpper === "ARCA" || exchangeUpper === "NYSEARCA") {
		return "NYSEARCA";
	}

	// OTC Pink variations
	if (
		exchangeUpper === "OTO" ||
		exchangeUpper === "PINL" ||
		exchangeUpper === "EXPM"
	) {
		return "OTCPK";
	}

	// Keep these as-is (already correct)
	if (exchangeUpper === "BATS") {
		return "BATS";
	}

	if (exchangeUpper === "OTCQX") {
		return "OTCQX";
	}

	if (exchangeUpper === "OTCQB") {
		return "OTCQB";
	}

	// Return original if no mapping found
	return exchange;
}

/**
 * Gets display name for normalized exchange
 */
export function getExchangeDisplayName(normalizedExchange) {
	switch (normalizedExchange) {
		case "NYSE":
			return "NYSE";
		case "NASDAQ":
			return "NASDAQ";
		case "AMEX":
			return "AMEX";
		case "NYSEARCA":
			return "NYSE Arca";
		case "BATS":
			return "NYSE American";
		case "OTCQX":
			return "OTCQX";
		case "OTCQB":
			return "OTCQB";
		case "OTCPK":
			return "OTCPK";
		default:
			return normalizedExchange;
	}
}
